export enum PaymentStatus {
  SUCCEEDED = 'succeeded',
  FAILED = 'failed',
}
